import React, { useState } from "react";
import classNames from "classnames";
import { DropdownItem } from "Components/ReactstrapSlim";
import useMediaBreakpointUp from "Hooks/useMediaBreakpointUp";
import { HeaderSolutions } from "./HeaderSolutions";
import { EnterpriseDemoRequestMode } from "Services/API/API";
import { ContactUsModal, FormType } from "Components/Modal";

interface HeaderDropDownMenuResourcesProps {
   isAuthenticated: boolean;
}

export const HeaderDropDownMenuResources: React.FC<HeaderDropDownMenuResourcesProps> = ({ isAuthenticated }) => {
   const isDropDownDisabled = useMediaBreakpointUp("md");

   const [isSolutionsExpanded, setSolutionsExpanded] = useState(false);
   const toggleSolutions = () => setSolutionsExpanded(!isSolutionsExpanded);
   const [enterpriseRequestModalOpened, setEnterpriseRequestModalOpened] = useState(false);
   const toggleEnterpriseRequestModal = () => setEnterpriseRequestModalOpened((wasOpened) => !wasOpened);

   return <>
      {
         isAuthenticated
            ? <DropdownItem disabled={isDropDownDisabled} tag="a" href="/enterprise" className="d-md-none">Enterprise</DropdownItem>
            : <div>
               <DropdownItem disabled={isDropDownDisabled} className={classNames("header-user-menu header-user-menu-solutions", { "header-user-menu--expanded": isSolutionsExpanded })} toggle={false} onClick={toggleSolutions}>Solutions</DropdownItem>
               {
                  HeaderSolutions.map(({ label, href }) => <DropdownItem disabled={!isSolutionsExpanded} key={label} tag="a" className="header-user-menu-item header-user-menu-solutions-item" href={href}>{label}</DropdownItem>)
               }
            </div>
      }
      <DropdownItem tag="a" href="/pricing" className="d-md-none">
         Pricing
      </DropdownItem>      
      <DropdownItem tag="a" href="https://resources.liquidspace.com" className="d-md-none" >
         Resources
      </DropdownItem>               
      <DropdownItem onClick={toggleEnterpriseRequestModal} toggle={false} className="d-md-none">
         Get demo
      </DropdownItem>
      {enterpriseRequestModalOpened && <ContactUsModal toggle={toggleEnterpriseRequestModal} isOpen={enterpriseRequestModalOpened} formType={FormType.Specific} formName="Get demo" mode={EnterpriseDemoRequestMode.Enterprise} centered />}
   </>
};